import { AnalyticsEvents } from '../../services/AnalyticsService'
import ElectronIPC from '../../services/ElectronIPC'
import useAnalytics from '../../services/useAnalytics'
import * as Constants from '../../services/Constants'
import { cn } from '../../utlis/cn'

type ProButtonProps = {
    className?: string
    children?: React.ReactNode
}
export function ProButton({ className, children }: ProButtonProps) {
    const border = 'border-muse-toplit-low rounded-[70px] group overflow-clip'
    const style = 'relative h-[40px] flex items-center cursor-pointer'

    const { logUserActivityWithContext } = useAnalytics()

    const onProUpgradeClick = () => {
        logUserActivityWithContext(AnalyticsEvents.CLICKED_UPGRADE_BUTTON)
        ElectronIPC.openLinkInBrowser(Constants.links.muse_pro_plans_link)
    }

    return (
        <div className={cn(style, border, className)} onClick={onProUpgradeClick}>
            <div className="absolute bottom-[2px] w-full h-full rounded-b-[30px]">
                <div className="flex w-[133%] -ml-[33%] group-hover:ml-0 h-full items-end transition-all duration-300 ease-in blur-[6px] group-hover:blur-[10px]">
                    <div className="h-[3px] w-[33%] rounded-t-full bg-[#FC5050] group-hover:scale-y-[2.5] transition-all duration-300 ease-in"></div>
                    <div className="h-[3px] w-[33%] rounded-t-full bg-[#FCE640] group-hover:scale-y-[2.5] transition-all duration-300 ease-in"></div>
                    <div className="h-[3px] w-[33%] rounded-t-full bg-[#85E0A3] group-hover:scale-y-[2.5] transition-all duration-300 ease-in"></div>
                    <div className="h-[3px] w-[33%] rounded-t-full bg-[#FC5050] group-hover:scale-y-[2.5] transition-all duration-300 ease-in"></div>
                </div>
            </div>
            <div className="w-full h-full px-6 rounded-[70px] flex items-center z-9">{children}</div>
        </div>
    )
}
